import { request as onLoginRequest, clear as onLoginClear } from 'src/modules/user/actions/login';
import { request as customersActionsOpenRequest } from 'src/modules/customers/actions/open';
import { request as onOpenEventRequest } from 'src/modules/events/actions/open';
import { request as onCloseEventRequest } from 'src/modules/events/actions/close';
import { request as getLiabilities } from 'src/modules/liabilities/actions/multiple';
import { request as getSingleLiabilities } from 'src/modules/liabilities/actions/get';
import { request as removeLiability } from 'src/modules/liabilities/actions/remove';
import { request as removeLiabilityMultiple } from 'src/modules/liabilities/actions/removeMultiple';
import { request as addLeg } from 'src/modules/betslip/actions/add-leg';
import { request as removeLeg } from 'src/modules/betslip/actions/remove-leg';
import { request as updateLeg } from 'src/modules/betslip/actions/update-leg';
import { request as getFreeBetCredits } from 'src/modules/customers/actions/get-freebet-credits';
import { request as updateBet } from 'src/modules/betslip/actions/update-bet';
import { request as queryAudit } from 'src/modules/audits/actions/query';
import { request as updateEvent } from 'src/modules/events/actions/update';
import { request as minimize } from 'src/modules/events/actions/minimize';
import { request as onEmailReportRequest } from 'src/modules/reports/actions/email';
import { getDocument as onGetDocumentReport } from 'src/modules/documents/actions/documents';

import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { request as addTricast } from 'src/modules/betslip/actions/add-tricast';
import { request as addForecast } from 'src/modules/betslip/actions/add-forecast';
import { request as getPossibleBets } from 'src/modules/betslip/actions/get-possible-bets';
import { ReduxRawState } from './Redux/utils/ReduxRawState';
import { ReduxBetslipState } from './Redux/ReduxBetslipState';
import { ReduxCustomerState } from './Redux/ReduxCustomerState';
import { request as createBlankSelection } from 'src/modules/markets/actions/add-selection';
import { request as addAllSelections } from 'src/modules/markets/actions/add-all-selections';
import { request as getMarketTemplates } from 'src/modules/market-templates/actions/get-list';

import addError from 'src/utils/error.jsx';
import { TypeId } from 'src_common/common/websocket2/type';
import { EventId, MarketId } from 'src_common/common/websocket2/id/WebsocketId';

type EventChangeResponseType =
    | {
          code: string;
          message: string;
          type: 'EventChangeResponseError';
      }
    | {
          type: 'EventChangeResponseOk';
      }
    | {
          body: string;
          code: number;
          type: 'EventChangeResponseUnknown';
      };

interface EventUpdateRequestType {
    active?: boolean;
    display?: boolean;
    timeSettings?: {
        tradedInPlay?: boolean;
    };
}

export class ReduxAction {
    private readonly reduxStore: ReduxRawState;

    public constructor(
        reduxStore: ReduxRawState,
        private readonly reduxBetslipState: ReduxBetslipState,
        private readonly reduxCustomerState: ReduxCustomerState
    ) {
        this.reduxStore = reduxStore;

        // const oldDispaych = this.reduxStore.dispatch;

        // this.reduxStore.dispatch = (data: unknown) => {
        //     console.info('oldDispaych ==> ', data);
        //     const response = oldDispaych(data);

        //     //@ts-expect-error
        //     const aaa = $appState.reduxStore.getState();
        //     const rrr = {};
        //     for (const [key, value] of Object.entries(aaa)) {
        //         //@ts-expect-error
        //         if (typeof value.toJS === 'function') {
        //             //@ts-expect-error
        //             rrr[key] = value.toJS();
        //         } else {
        //             //@ts-expect-error
        //             rrr[key] = value;
        //         }

        //     }

        //     console.info('rrr', rrr);

        //     return response;
        // };
    }

    public dispatchAction(actionData: unknown): void {
        this.reduxStore.dispatch(actionData);
    }

    public customersActionsOpenRequest(userId: number, name?: string, params?: Record<string, string>): void {
        this.dispatchAction(customersActionsOpenRequest(userId, name, params));
        this.dispatchAction(getFreeBetCredits(userId));
    }

    private onGetLiabilitiesSingleRequest = (eventId: number, marketId: number): void => {
        console.log('dispatchAction - onGetLiabilitiesSingleRequest :', eventId, marketId);
        this.dispatchAction(getSingleLiabilities(marketId, eventId));
    };

    private onGetLiabilitiesMultipleRequest = (eventId: number, marketId: number): void => {
        console.log('dispatchAction - onGetLiabilitiesMultipleRequest :', eventId, marketId);
        this.dispatchAction(getLiabilities(marketId, eventId));
    };

    public onGetLiabilitiesRequest = (newMarketId: MarketId, view: 'multiple' | 'single' | 'both'): void => {
        const marketId = newMarketId.toOldId();
        const eventId = newMarketId.getEventId().toOldId();

        console.log('dispatchAction - onGetLiabilitiesRequest :', eventId, marketId, view);
        if (view === 'multiple') {
            this.onGetLiabilitiesMultipleRequest(eventId, marketId);
        } else if (view === 'single') {
            this.onGetLiabilitiesSingleRequest(eventId, marketId);
        } else {
            this.onGetLiabilitiesSingleRequest(eventId, marketId);
            this.onGetLiabilitiesMultipleRequest(eventId, marketId);
        }
    };

    private onRemoveLiabilitiesSingleRequest = (marketId: number): void => {
        console.log('dispatchAction - onRemoveLiabilitiesSingleRequest :', marketId);
        this.dispatchAction(removeLiability(marketId));
    };

    private onRemoveLiabilitiesMultipleRequest = (marketId: number): void => {
        console.log('dispatchAction - onRemoveLiabilitiesMultipleRequest :', marketId);
        this.dispatchAction(removeLiabilityMultiple(marketId));
    };

    public onRemoveLiabilitiesRequest = (marketId: number, view: 'multiple' | 'single' | 'both'): void => {
        console.log('dispatchAction - onRemoveLiabilitiesRequest :', marketId, view);
        if (view === 'multiple') {
            this.onRemoveLiabilitiesMultipleRequest(marketId);
        } else if (view === 'single') {
            this.onRemoveLiabilitiesSingleRequest(marketId);
        } else {
            this.onRemoveLiabilitiesSingleRequest(marketId);
            this.onRemoveLiabilitiesMultipleRequest(marketId);
        }
    };

    public onMinimizeEvent = (params: { eventId: number; parameters: unknown }): void => {
        console.log('dispatchAction - onMinimizeEvent : ', params);
        this.dispatchAction(minimize(params));
    };

    public onOpenEventRequest = (eventId: number, silently: boolean = false): void => {
        console.log('dispatchAction - onOpenEventRequest : ', eventId, silently);
        if (silently) {
            this.dispatchAction(onOpenEventRequest(eventId, undefined, silently));
        } else {
            this.dispatchAction(onOpenEventRequest(eventId));
        }
    };

    public onCloseEventRequest = (eventId: number): void => {
        console.log('dispatchAction - onCloseEventRequest : ', eventId);
        this.dispatchAction(onCloseEventRequest(eventId));
    };

    public onBetslipRemoveLeg = (userId: number, market: MarketModel, selection: SelectionModel): void => {
        this.dispatchAction(
            removeLeg(userId, {
                selectionId: selection.id, // parseInt(selection.get('id'), 10),
                eventId: market.eventId, //parseInt(market.getIn([ 'event', 'id' ]), 10)
                marketId: TypeId.getMarketId(market.id), // '' + market.get('id'),
            })
        );
    };

    public onBetslipAddLeg = (userId: number, market: MarketModel, selection: SelectionModel): void => {
        const isDefaultEwOn = market.templateId.includes('each-way-extra');
        this.dispatchAction(
            addLeg(userId, {
                selectionId: selection.id, // parseInt(selection.get('id'), 10),
                marketId: TypeId.getMarketId(market.id), // '' + market.get('id'),
                eventId: market.eventId, // parseInt(market.getIn([ 'event', 'id' ]), 10),
                price: selection.price?.f, // selection.getIn([ 'price', 'f' ]),
                isMarketSp: market.sp, // market.get('sp'),
                priceType: 'fp', //selection.get('priceType')
                eachWay: isDefaultEwOn,
            })
        );
    };

    public onBetslipUpdateLeg = (userId: number, legUid: string, data: BetItemToUpdateType): void => {
        this.dispatchAction(updateLeg(userId, legUid, data));
    };

    public onBetslipUpdateBet = (userId: number, betUid: string, data: BetItemToUpdateType): void => {
        this.dispatchAction(updateBet(userId, betUid, data));
    };

    public onEmailReport = (documentId: string, reportType: string): void => {
        this.dispatchAction(onEmailReportRequest(documentId, reportType));
    };

    public onLoginRequest = (email: string, password: string): void => {
        this.dispatchAction(onLoginRequest(email, password));
    };

    public onLoginClear = (): void => {
        this.dispatchAction(onLoginClear());
    };

    public onGetDocumentReport = (documentId: string, title: string, format: string): void => {
        this.dispatchAction(onGetDocumentReport(documentId, title, format));
    };

    public onTricastAdd = (userId: number, type: 'TC' | 'CTC', legs: Array<LegItemType>): void => {
        this.dispatchAction(addTricast(userId, type, legs));
    };

    public onForecastAdd = (userId: number, type: 'FC' | 'RFC', legs: Array<LegItemType>): void => {
        this.dispatchAction(addForecast(userId, type, legs));
    };

    public loadEventAudit = (eventIdNew: EventId): void => {
        const eventId = eventIdNew.toOldId();

        const id = `trading_content_event-change-${eventId}`;
        const data = {
            topics: ['trading_content'],
            tags: [`event-change-${eventId}`],
        };

        this.dispatchAction(queryAudit(id, data));
    };

    public refreshPossibleBet = (userId: number): void => {
        const bets = this.reduxBetslipState.bets[userId] ?? null;
        const legs = this.reduxBetslipState.legs[userId] ?? null;
        const totalAmount = this.reduxCustomerState.freebetCredits[userId]?.data?.totalAmount ?? null;

        const isFreeBet = totalAmount === null ? false : totalAmount > 0;
        const legsArr = legs === null ? [] : Object.values(legs);

        this.dispatchAction(getPossibleBets(userId, bets ?? [], legsArr, 'telebetting', isFreeBet));
    };

    public refreshFreebets = (userId: number): void => {
        this.dispatchAction(getFreeBetCredits(userId));
    };

    public onEventUpdateRequest = (eventId: number, data: EventUpdateRequestType): void => {
        this.dispatchAction(updateEvent(eventId, data));
    };

    public onCreateBlankSelection = (
        eventId: number,
        marketIdBig: TypeId.MarketId,
        selectionTemplateID: string,
        params?: unknown
    ): void => {
        const marketId = TypeId.getMarketId(marketIdBig);
        console.log('dispatchAction - createBlankSelection :', eventId, marketId, selectionTemplateID, params);
        this.dispatchAction(createBlankSelection(eventId, marketId, selectionTemplateID, params));
    };

    public onAdAllSelections = (eventId: number, marketId: number, participants: unknown): void => {
        console.log('dispatchAction - addAllSelections', eventId, marketId, participants);
        this.dispatchAction(addAllSelections(eventId, marketId, participants));
    };

    public onQueryAudit = (id: string, data: unknown): void => {
        console.log('dispatchAction - queryAudit - ', id, data);
        this.dispatchAction(queryAudit(id, data));
    };

    public addError = (message: string): void => {
        addError(message);
    };

    public addErrorEventChange = (response: EventChangeResponseType): boolean => {
        if (response.type === 'EventChangeResponseError') {
            this.addError(response.message);
            return true;
        }

        if (response.type === 'EventChangeResponseUnknown') {
            const message = `Unknown http error: code=${response.code} body=${response.body}`;
            this.addError(message);
            return true;
        }

        return false;
    };

    public loadToReduxStoreMarketTemplates = (sportId: string): void => {
        this.dispatchAction(getMarketTemplates(sportId));
    };
}

export interface LegItemType {
    selectionId: number;
    marketId: number;
    eventId: number;
    price: string;
    isMarketSp: boolean;
    priceType: string;
}

export interface BetItemToUpdateType {
    eachWay?: boolean;
    legs?: Array<string>;
    type?: string;
    uid?: string;
    name?: string;
    numLines?: number;
    stakePerLine?: number | string;
    potentialReturnsAt?: number;
    potentialReturns?: number | null;
    isReferred?: boolean;
    errors?: Array<unknown>;
    isSplitted?: boolean;
    maxStake?: number;
    freebetCredits?: unknown;
    freebetRemarks?: unknown;
    freeBets?: Array<string> | null;
    price?: string | number | null;
}
